import React, { useRef } from 'react';
import { Typography, Box, Button, TablePagination, TextField, Snackbar, Divider, Tooltip, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { useEffect } from 'react';
import EditIcon from '@mui/icons-material/Edit';
import { useState } from 'react';
import moment from 'moment';
import { makeStyles } from '@mui/styles';
import { API, graphqlOperation } from 'aws-amplify';
import { Add, Done, Delete } from '@mui/icons-material';
import { createCompanyPreference, listOutstandingInvoiceMaster, listOutstandingPurchaseMaster } from '../../graphql';
import { showSuccessSnackbar, showWarningSnackbar } from '../snackBar/snakbar';
import CustomDateModal from '../modals/CustomDateModal';
import { defaultRowsPerPageOptions } from '../../utils/common';
import { useThemes } from '../Theme/theme';
import { useDispatch, useSelector } from 'react-redux';
import { MoneyFormatv3 } from '../../library/MoneyFormat';
import { companyPreferenceApi, useListCompanyPreferenceQuery } from '../../redux/apis/companyPreference.api';

const useStyles = makeStyles({
  table: {
    width: '100%',
    '& .MuiTableCell-root': {
      borderLeft: '1px solid #0000001f',
      minWidth: '40px',
    },
  },
});

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  boxShadow: 24,
  outline: 'none',
  width: '100%',
  maxHeight: { xs: '70%', sm: '100%' },
  overflowY: 'scroll',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
  scrollbarWidth: 'none',
  msOverflowStyle: 'none',
};
const DEFAULT_AGEING = [
  { from: 0, to: 30 },
  { from: 31, to: 60 },
  { from: 61, to: 90 },
];
let today = new Date();
let yy = today.getFullYear();
let mm = today.getMonth() + 1;
let dd = today.getDate();

if (dd < 10) dd = '0' + dd;
if (mm < 10) mm = '0' + mm;

const todayDate = yy + '-' + mm + '-' + dd;
const NewPayableReceivableAgeingTable = ({ open, setOpen, reportType, tableName }) => {
  const format = (num) =>
    Number(num).toLocaleString('en', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  const dispatch = useDispatch();
  const dashboardData = useSelector((state) => state?.DashboardDataReducer);
  const userPreferece = useSelector((state) => state.userPrefrenceandReducer);
  const { data: companyPreference } = useListCompanyPreferenceQuery();

  const savedAgeingArr = companyPreference
    ? JSON?.parse(companyPreference?.find((pref) => pref.attributetypecd === 'SelectedAgeing')?.additionalvalue)
    : DEFAULT_AGEING;

  // Convert to the desired format: { from: 0, to: 20 } without quotes for keys
  // Output: [ '{ from: 0, to: 20 }', '{ from: 31, to: 60 }', '{ from: 61, to: 90 }' ]

  const { startTimeStamp, endTimeStamp, range, basedOn } = dashboardData?.bsPeriod;
  const { theme } = useThemes();
  const fromDayRefs = useRef([]);
  const classes = useStyles();
  const [rows, setRows] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [page, setPage] = useState(0);
  const [selected, setSelected] = useState([]);
  const [dateRange, setDateRange] = useState('today');
  const [invDueDateRange, setInvDueDateRage] = useState('invoiceDate');
  const [backdropOpen, setBackdropOpen] = useState(false);
  const [customDateModal, setCustomDateModal] = useState(false);
  const [modalStartDate, setmodalStartDate] = useState('');
  const [modalEndDate, setmodalEndDate] = useState('');
  const [customDate, setCustomDate] = useState(todayDate);
  const [tableCell, setTableCell] = useState([]);
  const [fromToArr, setFromToArr] = useState([...savedAgeingArr]);

  const [warningSnakbar, setWarningSnakbar] = useState(false);
  const [enableEdit, setEnableEdit] = useState('');
  const [filterData, setFilterData] = useState([]);
  const [totalNetAmt, setTotalNetAmt] = useState([]);
  const [rowTotalBalanceDue, setRowTotalBalanceDue] = useState([]);
  const [selectedCell, setSelectedCell] = useState('');
  const [maxDaysTotal, setMaxDaysTotal] = useState(0);
  const [ageingBalance, setAgeingBalance] = useState(0);
  // Highlight ONLY the gap boundary values (previous "To" and next "From") after clicking "Update".
  const [showAgeingGapMarkers, setShowAgeingGapMarkers] = useState(false);
  const [ageingGapFromIndexes, setAgeingGapFromIndexes] = useState([]); // header indexes whose FROM value is a gap boundary
  const [ageingGapToIndexes, setAgeingGapToIndexes] = useState([]); // header indexes whose TO value is a gap boundary
  // Track all validation errors (not just gaps)
  const [showValidationMarkers, setShowValidationMarkers] = useState(false);
  const [validationErrorFromIndexes, setValidationErrorFromIndexes] = useState([]); // header indexes with FROM validation errors
  const [validationErrorToIndexes, setValidationErrorToIndexes] = useState([]); // header indexes with TO validation errors

  const [ageingShedule, setAgeingShedule] = useState({
    sheduleFrom: '',
    sheduleTo: '',
  });
  const [addEvent, setAddEvent] = useState(false);
  const lastValidFromValues = useRef({});
  const lastValidToValues = useRef({});

  const [editRow, setEditRow] = useState(null);
  const [addCell, setAddCell] = useState(false);
  const [totalRecord, setTotalRecord] = useState(0); //LEDX-5340
  //<--------//LEDX-5340-------------------->
  const [maxDaysTotalByCount, setMaxDaysTotalByCount] = useState(0);
  const [rowTotalBalanceDueByCount, setRowTotalBalanceDueByCount] = useState([]);
  const [totalAmtByTotalCount, setTotalAmtByTotalCount] = useState([]);
  const [rowsByTotalCount, setRowsByTotalCount] = useState([]);
  //<--------//LEDX-5340-------------------->

  const isSelected = (name) => selected.indexOf(name) !== -1;

  function addAgeingShedule() {
    setSelectedCell('');
    let isValid = true;
    let wrgMsg = '';
    
  const fromVal = ageingShedule.sheduleFrom;
  const toVal = ageingShedule.sheduleTo;
  if (fromVal === '' && toVal === '') {
    showWarningSnackbar('Schedule From and Schedule To are required');
    return;
  }

  if (fromVal === '') {
    showWarningSnackbar('Schedule From is required');
    return;
  }

  if (toVal === '') {
    showWarningSnackbar('Schedule To is required');
    return;
  }

    const newFrom = Number(ageingShedule.sheduleFrom);
    const newTo = Number(ageingShedule.sheduleTo);

    if (newFrom >= newTo) {
      isValid = false;
      wrgMsg = 'Schedule From should be less than Schedule To';
      showWarningSnackbar(wrgMsg);
      return;

    }

    const ageingCellCount = tableCell?.filter((ele) => ele?.icon === true).length || 0;
    

    if (Number(ageingCellCount) > 6) {
      isValid = false;
      showWarningSnackbar('You can add only up to 7 ageing columns.');
      return;
    }

    const allEmpty = tableCell.every((item) => item.fromDay === '' && item.toDay === '');
    if (!allEmpty) {
      tableCell
        .filter(
          (ele) =>
            ele.fromDay !== '' &&
            ele.fromDay !== null &&
            ele.fromDay !== undefined &&
            ele.toDay !== '' &&
            ele.toDay !== null &&
            ele.toDay !== undefined // LEDX-5656
        )
        .forEach((ele) => {
          const existingFrom = Number(ele?.fromDay);
          const existingTo = ele?.toDay === undefined || ele?.toDay === null ? 1000 : Number(ele.toDay);

          if (existingFrom === newFrom && existingTo === newTo) {
            isValid = false;
            wrgMsg = 'The selected period already exists';
            return;
          }

          if (existingFrom === newFrom) {
            isValid = false;
            wrgMsg = 'The Selected Schedule From range already exists';
            return;
          }
          if (existingTo === newTo) {
            isValid = false;
            wrgMsg = 'The Selected Schedule To range already exists';
            return;
          }

          const isOverlap =
            (newFrom >= existingFrom && newFrom <= existingTo) ||
            (newTo >= existingFrom && newTo <= existingTo) ||
            (existingFrom >= newFrom && existingTo <= newTo);

          if (isOverlap) {
            isValid = false;
            wrgMsg = 'The selected range overlaps with an existing period';
            return;
          }
        });
    }

    if (isValid) {
      setAddEvent(true);
      setAddCell(false);
      // setFromToArr((prev) => [...prev, { from: ageingShedule.sheduleFrom, to: ageingShedule.sheduleTo }]);
      const updated = [...fromToArr, { from: newFrom, to: newTo }].sort((a, b) => a.from - b.from);

      setFromToArr(updated);
      // saveSelectedAgeing(updated);

      setAgeingShedule((prev) => ({
        ...prev,
        sheduleFrom: '',
        sheduleTo: '',
      }));
      setEnableEdit(true);
      // Clear gap markers when new ageing is successfully added
    setShowValidationMarkers(false);
setValidationErrorFromIndexes([]);
setValidationErrorToIndexes([]);

setShowAgeingGapMarkers(false);
setAgeingGapFromIndexes([]);
setAgeingGapToIndexes([]);
    } else {
      showWarningSnackbar(wrgMsg);
    }
  }

  const handleAgeingClose = (index) => {
    const columnToDelete = tableCell[index];
    if (!columnToDelete || columnToDelete.icon !== true) {
      return;
    }

    // Validation: Check if this is the last ageing column
    const ageingColumnsCount = fromToArr.length;
    if (ageingColumnsCount <= 1) {
      showWarningSnackbar('Please keep at least one column');
      return;
    }

    // Get the range to delete
    const fromDay = columnToDelete.fromDay;
    const toDay = columnToDelete.toDay;
    const cellLabel = `${fromDay} - ${toDay} Days`;

    // Remove from fromToArr
    const updatedFromToArr = fromToArr.filter((ele) => !(Number(ele.from) === Number(fromDay) && Number(ele.to) === Number(toDay)));

    if (updatedFromToArr.length === fromToArr.length) {
      showWarningSnackbar('Could not find the ageing range to delete');
      return;
    }

    // Additional validation: Ensure at least one column remains after deletion
    if (updatedFromToArr.length === 0) {
      showWarningSnackbar('Please keep at least one column');
      return;
    }

    // Update fromToArr first
    setFromToArr(updatedFromToArr);

    // Set selectedCell to trigger deletion logic in setTableHead
    // This will trigger useEffect which calls getAgeingData -> setTableHead
    setSelectedCell(cellLabel);

    // Save updated ageing preferences
    // saveSelectedAgeing(updatedFromToArr);

    // Clear gap markers
    setShowAgeingGapMarkers(false);
    setAgeingGapFromIndexes([]);
    setAgeingGapToIndexes([]);

    // Clear selectedCell after a delay to allow setTableHead to process
    setTimeout(() => {
      setSelectedCell('');
    }, 200);

    showSuccessSnackbar('Ageing column deleted successfully');
  };

  async function getAgeingData(dateRange, customDate, value, rowfrom, limitno, open, mode, searchArr, reset) {
    try {
      setBackdropOpen(true);
      let selectedDate;
      const rows = [];
      let totalRecord = 0;

      if (dateRange === 'today') {
        const today = new Date();
        today.setUTCHours(0, 0, 0, 0);
        selectedDate = Math.floor(today.getTime() / 1000); // UTC timestamp in seconds
      } else {
        const date = new Date(customDate);
        date.setUTCHours(0, 0, 0, 0);
        selectedDate = Math.floor(date.getTime() / 1000); // UTC timestamp in seconds
      }

      const query = reportType === 'ReceivableOutStanding' ? listOutstandingInvoiceMaster : listOutstandingPurchaseMaster;

      const resData = await API.graphql(
        graphqlOperation(query, {
          startdate: startTimeStamp,
          enddate: endTimeStamp,
          rowfrom: rowfrom,
          limitno: limitno,
          word: value,
          searchmode: mode,
          ordertype: 'DESC',
          columnname: 'enteredtimestamp', // Fixed typo: "enteredtimesstamp"
          searcharray: JSON.stringify(searchArr),
          ageing: range === 'date' ? 0 : 1,
          basedon: basedOn === 'invoiceDate' ? 1 : 0,
        })
      );

      const outstandingData =
        reportType === 'ReceivableOutStanding' ? resData?.data?.listOutstandingInvoiceMaster : resData?.data?.listOutstandingPurchaseMaster;

      outstandingData.forEach((data) => {
        let invoiceDateTS = 0;
        let dueDateTS = data?.duedate * 1000;

        if (reportType === 'ReceivableOutStanding') {
          invoiceDateTS = data?.invoicedate * 1000;
          data.invoiceDate = moment(invoiceDateTS).format('DD-MMM-YYYY');
          data.dueDate = moment(dueDateTS).format('DD-MMM-YYYY');
          data.voucherNo = data?.invoicenumber;
          data.dueDays = Math.abs(Number(data?.overduedays));
          data.totalCount = data?.recordcount;
          totalRecord = data?.recordcount;
        } else {
          invoiceDateTS = data?.purchaseinvoicedate * 1000;
          data.invoiceDate = moment(invoiceDateTS).format('DD-MMM-YYYY');
          data.dueDate = moment(dueDateTS).format('DD-MMM-YYYY');
          data.voucherNo = data?.purchaseinvoicenumber;
          data.dueDays = Math.abs(Number(data?.overduedays));
          data.totalCount = data?.recordcount;
          totalRecord = data?.recordcount;
        }

        const isDueDateMode = invDueDateRange === 'dueDate';
        const targetDate = isDueDateMode ? dueDateTS : invoiceDateTS;

        // if (targetDate <= selectedDate) {
        rows.push(data);
        // }
      });
      //LEDX-5340
      if (Number(totalRecord) > 0) {
        getAgeingDataByTotalCount(dateRange, customDate, value, 0, totalRecord, open, mode, searchArr, reset);
      }
      setTotalRecord(totalRecord);
      //LEDX-5340

      if (reset === true) {
        setRows(rows);
        setTableHead(rows);
      } else {
        setRows((prevData) => {
          const updatedData = [...prevData, ...rows];
          setTableHead(updatedData);
          return updatedData;
        });
      }

      // setRows(rows);
      // setTableHead(rows);
      setBackdropOpen(false);
    } catch (error) {
      setBackdropOpen(false);
      console.log('error', error);
      setBackdropOpen(false);
    }
  }

  useEffect(() => {
    getAgeingData(dateRange, customDate, '', 0, rowsPerPage, true, 0, [], true);
  }, [addEvent, dateRange, invDueDateRange, customDate, selectedCell, open, rowsPerPage]);
  useEffect(() => {
    getAgeingData(dateRange, customDate, '', 0, 25, true, 0, [], true);
    setPage(0);
    setRowsPerPage(25);
  }, [endTimeStamp, startTimeStamp, basedOn, range]);

  function setTableHead(rows) {
    const [selFrom, , selTo] = selectedCell.split(' '); // "61", "-", "90"
    // const maxToDay = Math.max(...fromToArr.map((ele) => Number(ele.to)));
    const filteredArr = fromToArr.filter((ele) => !(Number(ele.from) === Number(selFrom) && Number(ele.to) === Number(selTo)));

    const maxToDay = filteredArr.length === 0 ? 0 : Math.max(...filteredArr.map((ele) => Number(ele.to)));

    setAddEvent(false);

    let serialNoArr = [
      {
        id: 'SL.No',
        label: 'SL.No',
        minWidth: 80,
        fromDay: '',
        toDay: '',
        icon: false,
      },
    ];
    let displyNameArr = [
      {
        id: 'PartyName',
        label: reportType === 'ReceivableOutStanding' ? 'Customer Name' : 'Supplier Name',
        minWidth: 80,
        fromDay: '',
        toDay: '',
        icon: false,
      },
    ];
    let displayInvoiceNoArr = [
      {
        id: 'VoucherNo',
        label: reportType === 'ReceivableOutStanding' ? 'Invoice No' : 'Voucher No',
        minWidth: 80,
        fromDay: '',
        toDay: '',
        icon: false,
      },
    ];
    let displayInvoiceDateArr = [
      {
        id: 'VoucherDate',
        label: reportType === 'ReceivableOutStanding' ? 'Invoice Date' : 'Purchase Date',
        minWidth: 80,
        fromDay: '',
        toDay: '',
        icon: false,
      },
    ];
    let displayDueDateArr = [
      {
        id: 'Due Date',
        label: 'Due Date',
        minWidth: 80,
        fromDay: '',
        toDay: '',
        icon: false,
      },
    ];
    let totArr = [
      {
        id: 'Total',
        label: 'Total',
        minWidth: 80,
        fromDay: '',
        toDay: '',
        icon: false,
      },
    ];
    let maxDaysArr = [
      {
        id: 'maxToDay',
        label: maxToDay + '+' + ' ' + 'Days',
        minWidth: 80,
        fromDay: '',
        toDay: '',
        icon: false,
      },
    ];
    let daysArr = [];
    fromToArr.map((ele) => {
      daysArr.push({
        id: ele.from + ' ' + '-' + ' ' + ele.to + ' ' + 'Days',
        label: ele.from + ' ' + '-' + ' ' + ele.to + ' ' + 'Days',
        minWidth: '80px',
        fromDay: ele.from,
        toDay: ele.to,
        diffday: Number(ele.to) - Number(ele.from),
        icon: true,
      });
    });
    let totBalanceDueAmount = 0;
    let totRowAmount = 0;
    let startNo = 0;
    let endNo = 0;
    let arrOfBalancDue = [];
    daysArr = [...daysArr]?.sort((a, b) => a.toDay - b.toDay);
    if (selectedCell !== '') {
      daysArr = daysArr.filter((ele) => {
        if (ele.label !== selectedCell) {
          return ele;
        }
      });
      daysArr = [...daysArr]?.sort((a, b) => a.toDay - b.toDay);
      let filterRowTotalBalanceDue = rowTotalBalanceDue.filter((ele) => {
        if (ele.period !== selectedCell) {
          return ele;
        }
      });
      let cellSelected = selectedCell.split(' ');
      let filterArr = fromToArr.filter((ele) => {
        if (ele.from !== Number(cellSelected[0]) && ele.to !== cellSelected[2]) {
          return ele;
        }
      });
      setFromToArr(filterArr);
    }
    rows.map((col) => {
      col.amtArr = [];
      col.newAmtArr = [];
      daysArr.map((ele) => {
        col.amtArr.push({
          label: ele.fromDay + ' ' + '-' + ' ' + ele.toDay + ' ' + 'Days',
          amount: col.dueDays >= ele.fromDay && col.dueDays <= ele.toDay ? Number(col?.balancedueamount).toFixed(2) : 0,
        });

        startNo = ele.fromDay;
        endNo = ele.toDay;
        if (col.dueDays >= startNo && col.dueDays <= endNo) {
          arrOfBalancDue.push({
            label: startNo + ' ' + '-' + ' ' + endNo + ' ' + 'Days',
            amount: col.balancedueamount,
          });
        } else {
          arrOfBalancDue.push({
            label: startNo + ' ' + '-' + ' ' + endNo + ' ' + 'Days',
            amount: 0,
          });
        }
      });
      col.amtArr.map((ele) => {
        totBalanceDueAmount += Number(ele.amount);
      });
    });
    const uniqueIds = [];
    let tempArray = [];
    const unique = arrOfBalancDue.filter((element) => {
      const isDuplicate = uniqueIds.includes(element.label);
      if (!isDuplicate) {
        uniqueIds.push(element.label);
        tempArray.push({
          period: element.label,
          balanceDueAmt: element.amount,
        });
        return true;
      } else {
        tempArray.map((item) => {
          if (element.label === item.period) {
            item.balanceDueAmt = Number(element.amount) + Number(item.balanceDueAmt);
          }
        });
      }
      return false;
    });
    setRowTotalBalanceDue(tempArray);
    let newRows = [];

    rows.map((ele) => {
      newRows.push({
        PartyName: ele?.partylegalname,
        InvoiceNumber: ele?.voucherNo,
        InvoiceDate: ele?.invoiceDate,
        DueDate: ele?.dueDate,
        arr: ele.amtArr,
        maxDaysBalanceAmt: ele?.dueDays > maxToDay ? Number(ele?.balancedueamount) : 0,
        totalCount: ele?.totalCount,
      });
    });

    const uniqueIdsArr = [];
    let tempArrayArr = [];
    let maxDaysTotal = 0;
    const uniqueArr = newRows.filter((element) => {
      const isDuplicateArr = uniqueIdsArr.includes(element.InvoiceNumber);
      if (!isDuplicateArr) {
        uniqueIdsArr.push(element.InvoiceNumber);
        tempArrayArr.push({
          PartyName: element.PartyName,
          InvoiceNumber: element.InvoiceNumber,
          InvoiceDate: element?.InvoiceDate,
          DueDate: element?.DueDate,
          arr: element.arr,
          maxDaysBalanceAmt: element?.maxDaysBalanceAmt,
          totalCount: element?.totalCount,
        });
        return true;
      } else {
        tempArrayArr.map((item) => {
          if (element.InvoiceNumber === item.InvoiceNumber) {
            item.arr = [...item.arr, ...element.arr];
          }
        });
      }
      return false;
    });
    tempArrayArr.map((ele) => {
      const uniqueIds = [];
      let tempArray = [];
      const unique = ele.arr.filter((element) => {
        const isDuplicate = uniqueIds.includes(element.label);
        if (!isDuplicate) {
          uniqueIds.push(element.label);
          tempArray.push({
            period: element.label,
            balanceDueAmt: element.amount,
          });
          return true;
        } else {
          tempArray.map((item) => {
            if (element.label === item.period) {
              item.balanceDueAmt = Number(element.amount) + Number(item.balanceDueAmt);
            }
          });
        }
        return false;
      });
      ele.arr = tempArray;
    });
    maxDaysTotal = tempArrayArr.reduce((sum, item) => sum + item.maxDaysBalanceAmt, 0);
    setMaxDaysTotal(maxDaysTotal);
    setFilterData(tempArrayArr);
    let combinedArr = [
      ...serialNoArr,
      ...displyNameArr,
      ...displayInvoiceNoArr,
      ...displayInvoiceDateArr,
      ...displayDueDateArr,
      ...daysArr,
      ...maxDaysArr,
      ...totArr,
    ];
    setTableCell(combinedArr);
  }

  const hasOverlap = (ranges) => {
  const sorted = [...ranges].sort((a, b) => a.from - b.from);
  for (let i = 1; i < sorted.length; i++) {
    if (sorted[i].from <= sorted[i - 1].to) {
      return true;
    }
  }
  return false;
};

  const handleRangeChange = (from, to, index) => {
    let updatedTableArr = [...tableCell];
    let updatedFromToArr = [...fromToArr];
    let updatedFilterData = [...filterData];
    let updatedRows = [...rows];
    let maxToDay = Math.max(...updatedFromToArr.map((ele) => Number(ele.to)));
    let serialNoArr = [
      {
        id: 'SL.No',
        label: 'SL.No',
        minWidth: 80,
        fromDay: '',
        toDay: '',
        icon: false,
      },
    ];
    let displyNameArr = [
      {
        id: 'PartyName',
        label: reportType === 'ReceivableOutStanding' ? 'Customer Name' : 'Supplier Name',
        minWidth: 80,
        fromDay: '',
        toDay: '',
        icon: false,
      },
    ];
    let displayInvoiceNoArr = [
      {
        id: 'VoucherNo',
        label: reportType === 'ReceivableOutStanding' ? 'Invoice No' : 'Voucher No',
        minWidth: 80,
        fromDay: '',
        toDay: '',
        icon: false,
      },
    ];
    let displayInvoiceDateArr = [
      {
        id: 'VoucherDate',
        label: reportType === 'ReceivableOutStanding' ? 'Invoice Date' : 'Purchase Date',
        minWidth: 80,
        fromDay: '',
        toDay: '',
        icon: false,
      },
    ];
    let displayDueDateArr = [
      {
        id: 'Due Date',
        label: 'Due Date',
        minWidth: 80,
        fromDay: '',
        toDay: '',
        icon: false,
      },
    ];
    let totArr = [
      {
        id: 'Total',
        label: 'Total',
        minWidth: 80,
        fromDay: '',
        toDay: '',
        icon: false,
      },
    ];
    const oldFrom = updatedTableArr[index].fromDay;
    const oldTo = updatedTableArr[index].toDay;
    let newFromDay = from === '' ? 0 : Number(from);
    let newToDay = to === '' ? 0 : Number(to);
    const fromChanged = newFromDay !== oldFrom;
    const toChanged = newToDay !== oldTo;

    const isDuplicate = updatedFromToArr.some((range) => range.from === newFromDay && range.to === newToDay);

    updatedTableArr[index] = {
      ...updatedTableArr[index],
      fromDay: newFromDay,
      toDay: newToDay,
      id: `${newFromDay} - ${newToDay} Days`,
      label: `${newFromDay} - ${newToDay} Days`,
      diffday: newToDay - newFromDay,
    };

    updatedFromToArr[index - 5] = {
      ...updatedFromToArr[index - 5],
      from: newFromDay,
      to: newToDay,
    };

    let daysArr = [];
    updatedTableArr?.forEach((ele) => {
      if (ele.fromDay !== '' && ele.toDay !== '' && ele.icon === true) {
        daysArr.push({
          id: ele.fromDay + ' ' + '-' + ' ' + ele.toDay + ' ' + 'Days',
          label: ele.fromDay + ' ' + '-' + ' ' + ele.toDay + ' ' + 'Days',
          minWidth: '80px',
          fromDay: ele.fromDay,
          toDay: ele.toDay,
          diffday: Number(ele.toDay) - Number(ele.fromDay),
          icon: true,
        });
      }
    });
    // daysArr = daysArr.sort((a, b) => Number(a.fromDay) - Number(b.fromDay));
    const overlapExists = hasOverlap(
  daysArr.map((d) => ({ from: d.fromDay, to: d.toDay }))
);

if (!overlapExists) {
  daysArr = daysArr.sort((a, b) => Number(a.fromDay) - Number(b.fromDay));
}

    updatedFromToArr = daysArr.map((ele) => ({
      from: ele.fromDay,
      to: ele.toDay,
    }));

    maxToDay = Math.max(...daysArr.map((ele) => Number(ele.toDay)));
    let maxDaysArr = [
      {
        id: 'maxToDay',
        label: maxToDay + '+' + ' ' + 'Days',
        minWidth: 80,
        fromDay: '',
        toDay: '',
        icon: false,
      },
    ];
    let totBalanceDueAmount = 0;
    let totRowAmount = 0;
    let startNo = 0;
    let endNo = 0;
    let arrOfBalancDue = [];
    updatedRows?.map((col) => {
      col.amtArr = [];
      col.newAmtArr = [];
      daysArr?.map((ele) => {
        col.amtArr.push({
          label: ele.fromDay + ' ' + '-' + ' ' + ele.toDay + ' ' + 'Days',
          amount: col.dueDays >= ele.fromDay && col.dueDays <= ele.toDay ? Number(col?.balancedueamount).toFixed(2) : 0,
        });

        startNo = ele.fromDay;
        endNo = ele.toDay;
        if (col.dueDays >= startNo && col.dueDays <= endNo) {
          arrOfBalancDue.push({
            label: startNo + ' ' + '-' + ' ' + endNo + ' ' + 'Days',
            amount: col.balancedueamount,
          });
        } else {
          arrOfBalancDue.push({
            label: startNo + ' ' + '-' + ' ' + endNo + ' ' + 'Days',
            amount: 0,
          });
        }
      });
      col.amtArr.map((ele) => {
        totBalanceDueAmount += Number(ele.amount);
      });
    });
    const uniqueIds = [];
    let tempArray = [];
    const unique = arrOfBalancDue.filter((element) => {
      const isDuplicate = uniqueIds.includes(element.label);
      if (!isDuplicate) {
        uniqueIds.push(element.label);
        tempArray.push({
          period: element.label,
          balanceDueAmt: element.amount,
        });
        return true;
      } else {
        tempArray.map((item) => {
          if (element.label === item.period) {
            item.balanceDueAmt = Number(element.amount) + Number(item.balanceDueAmt);
          }
        });
      }
      return false;
    });
    setRowTotalBalanceDue(tempArray);
    let newRows = [];
    rows.map((ele) => {
      newRows.push({
        PartyName: ele?.partylegalname,
        InvoiceNumber: ele?.voucherNo,
        InvoiceDate: ele?.invoiceDate,
        DueDate: ele?.dueDate,
        arr: ele.amtArr,
        maxDaysBalanceAmt: ele?.dueDays > maxToDay ? Number(ele?.balancedueamount) : 0,
        totalCount: ele?.totalCount,
      });
    });

    const uniqueIdsArr = [];
    let tempArrayArr = [];
    const uniqueArr = newRows.filter((element) => {
      const isDuplicateArr = uniqueIdsArr.includes(element.InvoiceNumber);
      if (!isDuplicateArr) {
        uniqueIdsArr.push(element.InvoiceNumber);
        tempArrayArr.push({
          PartyName: element.PartyName,
          InvoiceNumber: element.InvoiceNumber,
          InvoiceDate: element?.InvoiceDate,
          DueDate: element?.DueDate,
          arr: element.arr,
          maxDaysBalanceAmt: element?.maxDaysBalanceAmt,
          totalCount: element?.totalCount,
        });
        return true;
      } else {
        tempArrayArr.map((item) => {
          if (element.InvoiceNumber === item.InvoiceNumber) {
            item.arr = [...item.arr, ...element.arr];
          }
        });
      }
      return false;
    });

    tempArrayArr.map((ele) => {
      const uniqueIds = [];
      let tempArray = [];
      const unique = ele.arr.filter((element) => {
        const isDuplicate = uniqueIds.includes(element.label);
        if (!isDuplicate) {
          uniqueIds.push(element.label);
          tempArray.push({
            period: element.label,
            balanceDueAmt: element.amount,
          });
          return true;
        } else {
          tempArray.map((item) => {
            if (element.label === item.period) {
              item.balanceDueAmt = Number(element.amount) + Number(item.balanceDueAmt);
            }
          });
        }
        return false;
      });
      ele.arr = tempArray;
    });
    let maxDaysTotal = 0;
    maxDaysTotal = tempArrayArr.reduce((sum, item) => sum + item.maxDaysBalanceAmt, 0);
    setMaxDaysTotal(maxDaysTotal);
    setFilterData(tempArrayArr);

    let combinedArr = [
      ...serialNoArr,
      ...displyNameArr,
      ...displayInvoiceNoArr,
      ...displayInvoiceDateArr,
      ...displayDueDateArr,
      ...daysArr,
      ...maxDaysArr,
      ...totArr,
    ];

    setFromToArr(updatedFromToArr);
    setTableCell(combinedArr);
  };
  //<---------------------LEDX-5340--------------------------------------------->
  function parseToCents(amount) {
    if (!amount || amount === 0 || amount === '0') return 0n;
    const str = Number(amount).toFixed(2);
    const [integer, decimal = '00'] = str.split('.');
    return BigInt(integer.replace(/[^0-9]/g, '') + decimal.replace(/[^0-9]/g, ''));
  }
  function formatFromCents(totalCents) {
    const abs = totalCents < 0n ? totalCents * -1n : totalCents;
    const integer = (abs / 100n).toString();
    const cents = (abs % 100n).toString().padStart(2, '0');
    return totalCents < 0n ? `-${integer}.${cents}` : `${integer}.${cents}`;
  }
  async function getAgeingDataByTotalCount(dateRange, customDate, value, rowfrom, limitno, open, mode, searchArr, reset) {
    try {
      let selectedDate;
      const rows = [];
      let totalRecord = 0;

      if (dateRange === 'today') {
        const today = new Date();
        today.setUTCHours(0, 0, 0, 0);
        selectedDate = Math.floor(today.getTime() / 1000); // UTC timestamp in seconds
      } else {
        const date = new Date(customDate);
        date.setUTCHours(0, 0, 0, 0);
        selectedDate = Math.floor(date.getTime() / 1000); // UTC timestamp in seconds
      }

      const query = reportType === 'ReceivableOutStanding' ? listOutstandingInvoiceMaster : listOutstandingPurchaseMaster;

      const resData = await API.graphql(
        graphqlOperation(query, {
          startdate: startTimeStamp,
          enddate: endTimeStamp,
          rowfrom: rowfrom,
          limitno: limitno,
          word: value,
          searchmode: mode,
          ordertype: 'DESC',
          columnname: 'enteredtimestamp', // Fixed typo: "enteredtimesstamp"
          searcharray: JSON.stringify(searchArr),
          ageing: range === 'date' ? 0 : 1,
          basedon: basedOn === 'invoiceDate' ? 1 : 0,
        })
      );

      const outstandingData =
        reportType === 'ReceivableOutStanding' ? resData?.data?.listOutstandingInvoiceMaster : resData?.data?.listOutstandingPurchaseMaster;
      //  setTotalAmtByTotalCount( outstandingData[0]?.total_balancedueamount)
      setTotalNetAmt(outstandingData[0]?.total_balancedueamount);

      outstandingData.forEach((data) => {
        let invoiceDateTS = 0;
        let dueDateTS = data?.duedate * 1000;

        if (reportType === 'ReceivableOutStanding') {
          invoiceDateTS = data?.invoicedate * 1000;
          data.invoiceDate = moment(invoiceDateTS).format('DD-MMM-YYYY');
          data.dueDate = moment(dueDateTS).format('DD-MMM-YYYY');
          data.voucherNo = data?.invoicenumber;
          data.dueDays = Math.abs(Number(data?.overduedays));
          data.totalCount = data?.recordcount;
          totalRecord = data?.recordcount;
          data.balancedueamount = Math.round(data?.balancedueamount * 100) / 100;
        } else {
          invoiceDateTS = data?.purchaseinvoicedate * 1000;
          data.invoiceDate = moment(invoiceDateTS).format('DD-MMM-YYYY');
          data.dueDate = moment(dueDateTS).format('DD-MMM-YYYY');
          data.voucherNo = data?.purchaseinvoicenumber;
          data.dueDays = Math.abs(Number(data?.overduedays));
          data.totalCount = data?.recordcount;
          totalRecord = data?.recordcount;
          data.balancedueamount = Math.round(data?.balancedueamount * 100) / 100;
        }

        const isDueDateMode = invDueDateRange === 'dueDate';
        const targetDate = isDueDateMode ? dueDateTS : invoiceDateTS;

        rows.push(data);
      });
      setRowsByTotalCount(rows);
      setTableHeadByTotalCount(rows, outstandingData[0]?.total_balancedueamount);
    } catch (error) {
      console.log('error', error);
    }
  }
  function setTableHeadByTotalCount(rows, totalNetAmt) {
    const [selFrom, , selTo] = selectedCell.split(' ');
    const filteredArr = fromToArr.filter((ele) => !(Number(ele.from) === Number(selFrom) && Number(ele.to) === Number(selTo)));

    const maxToDay = filteredArr.length === 0 ? 0 : Math.max(...filteredArr.map((ele) => Number(ele.to)));

    let serialNoArr = [
      {
        id: 'SL.No',
        label: 'SL.No',
        minWidth: 80,
        fromDay: '',
        toDay: '',
        icon: false,
      },
    ];
    let displyNameArr = [
      {
        id: 'PartyName',
        label: reportType === 'ReceivableOutStanding' ? 'Customer Name' : 'Supplier Name',
        minWidth: 80,
        fromDay: '',
        toDay: '',
        icon: false,
      },
    ];
    let displayInvoiceNoArr = [
      {
        id: 'VoucherNo',
        label: reportType === 'ReceivableOutStanding' ? 'Invoice No' : 'Voucher No',
        minWidth: 80,
        fromDay: '',
        toDay: '',
        icon: false,
      },
    ];
    let displayInvoiceDateArr = [
      {
        id: 'VoucherDate',
        label: reportType === 'ReceivableOutStanding' ? 'Invoice Date' : 'Purchase Date',
        minWidth: 80,
        fromDay: '',
        toDay: '',
        icon: false,
      },
    ];
    let displayDueDateArr = [
      {
        id: 'Due Date',
        label: 'Due Date',
        minWidth: 80,
        fromDay: '',
        toDay: '',
        icon: false,
      },
    ];
    let totArr = [
      {
        id: 'Total',
        label: 'Total',
        minWidth: 80,
        fromDay: '',
        toDay: '',
        icon: false,
      },
    ];
    let maxDaysArr = [
      {
        id: 'maxToDay',
        label: maxToDay + '+' + ' ' + 'Days',
        minWidth: 80,
        fromDay: '',
        toDay: '',
        icon: false,
      },
    ];
    let daysArr = [];
    fromToArr.map((ele) => {
      daysArr.push({
        id: ele.from + ' ' + '-' + ' ' + ele.to + ' ' + 'Days',
        label: ele.from + ' ' + '-' + ' ' + ele.to + ' ' + 'Days',
        minWidth: '80px',
        fromDay: ele.from,
        toDay: ele.to,
        diffday: Number(ele.to) - Number(ele.from),
        icon: true,
      });
    });
    let totBalanceDueAmount = 0;
    let totRowAmount = 0;
    let startNo = 0;
    let endNo = 0;
    let arrOfBalancDue = [];
    daysArr = [...daysArr]?.sort((a, b) => a.toDay - b.toDay);
    if (selectedCell !== '') {
      daysArr = daysArr.filter((ele) => {
        if (ele.label !== selectedCell) {
          return ele;
        }
      });
      daysArr = [...daysArr]?.sort((a, b) => a.toDay - b.toDay);
      let filterRowTotalBalanceDue = rowTotalBalanceDue.filter((ele) => {
        if (ele.period !== selectedCell) {
          return ele;
        }
      });
      let cellSelected = selectedCell.split(' ');
      let filterArr = fromToArr.filter((ele) => {
        if (ele.from !== Number(cellSelected[0]) && ele.to !== cellSelected[2]) {
          return ele;
        }
      });
    }
    rows.map((col) => {
      col.amtArr = [];
      col.newAmtArr = [];
      daysArr.map((ele) => {
        col.amtArr.push({
          label: ele.fromDay + ' ' + '-' + ' ' + ele.toDay + ' ' + 'Days',
          amount: col.dueDays >= ele.fromDay && col.dueDays <= ele.toDay ? Number(col?.balancedueamount).toFixed(2) : 0,
        });

        startNo = ele.fromDay;
        endNo = ele.toDay;
        if (col.dueDays >= startNo && col.dueDays <= endNo) {
          arrOfBalancDue.push({
            label: startNo + ' ' + '-' + ' ' + endNo + ' ' + 'Days',
            amount: col.balancedueamount,
          });
        } else {
          arrOfBalancDue.push({
            label: startNo + ' ' + '-' + ' ' + endNo + ' ' + 'Days',
            amount: 0,
          });
        }
      });
      col.amtArr.map((ele) => {
        totBalanceDueAmount += Number(ele.amount);
      });
    });

    const uniqueIds = [];
    let tempArray = [];

    arrOfBalancDue.forEach((element) => {
      const label = element.label;
      const amt = Number(element.amount || 0); // rupees

      if (!uniqueIds.includes(label)) {
        uniqueIds.push(label);

        tempArray.push({
          period: label,
          balanceDueAmt: parseToCents(amt), // store as cents (BigInt)
        });
      } else {
        tempArray.map((item) => {
          if (item.period === label) {
            const prevCents = item.balanceDueAmt; // BigInt
            const newCents = parseToCents(amt); // BigInt
            item.balanceDueAmt = prevCents + newCents; // BigInt addition
          }
        });
      }
    });

    // Convert cents → rupees ONLY for UI display
    const finalTempArray = tempArray.map((item) => ({
      period: item.period,
      balanceDueAmt: formatFromCents(item.balanceDueAmt), // always EXACT 2 decimals
    }));

    setRowTotalBalanceDueByCount(finalTempArray);

    let newRows = [];

    rows.map((ele) => {
      newRows.push({
        PartyName: ele?.partylegalname,
        InvoiceNumber: ele?.voucherNo,
        InvoiceDate: ele?.invoiceDate,
        DueDate: ele?.dueDate,
        arr: ele.amtArr,
        maxDaysBalanceAmt: ele?.dueDays > maxToDay ? Number(ele?.balancedueamount) : 0,
        totalCount: ele?.totalCount,
      });
    });

    const uniqueIdsArr = [];
    let tempArrayArr = [];
    let maxDaysTotal = 0;
    const uniqueArr = newRows.filter((element) => {
      const isDuplicateArr = uniqueIdsArr.includes(element.InvoiceNumber);
      if (!isDuplicateArr) {
        uniqueIdsArr.push(element.InvoiceNumber);
        tempArrayArr.push({
          PartyName: element.PartyName,
          InvoiceNumber: element.InvoiceNumber,
          InvoiceDate: element?.InvoiceDate,
          DueDate: element?.DueDate,
          arr: element.arr,
          maxDaysBalanceAmt: element?.maxDaysBalanceAmt,
          totalCount: element?.totalCount,
        });
        return true;
      } else {
        tempArrayArr.map((item) => {
          if (element.InvoiceNumber === item.InvoiceNumber) {
            item.arr = [...item.arr, ...element.arr];
          }
        });
      }
      return false;
    });
    tempArrayArr.map((ele) => {
      const uniqueIds = [];
      let tempArray = [];
      const unique = ele.arr.filter((element) => {
        const isDuplicate = uniqueIds.includes(element.label);
        if (!isDuplicate) {
          uniqueIds.push(element.label);
          tempArray.push({
            period: element.label,
            balanceDueAmt: element.amount,
          });
          return true;
        } else {
          tempArray.map((item) => {
            if (element.label === item.period) {
              item.balanceDueAmt = Number(element.amount) + Number(item.balanceDueAmt);
            }
          });
        }
        return false;
      });
      ele.arr = tempArray;
    });
    let maxDaysCents = 0n;
    tempArrayArr.forEach((item) => {
      if (item.maxDaysBalanceAmt !== 0 && item.maxDaysBalanceAmt !== '0') {
        maxDaysCents += parseToCents(item.maxDaysBalanceAmt);
      }
    });
    const maxDaysTotalStr = formatFromCents(maxDaysCents);
    setMaxDaysTotalByCount(maxDaysTotalStr);

    const totalCents1 = parseToCents(totBalanceDueAmount);
    const totalCents2 = maxDaysCents;
    const grandTotalCents = totalCents1 + totalCents2;
    const grandTotalStr = formatFromCents(grandTotalCents);
    let ageingBalance = 0;
    ageingBalance = Number(totalNetAmt) - Number(grandTotalCents);
    setAgeingBalance(ageingBalance);

    // Already ensures exactly 2 decimals
    setTotalAmtByTotalCount(grandTotalStr);

    let combinedArr = [
      ...serialNoArr,
      ...displyNameArr,
      ...displayInvoiceNoArr,
      ...displayInvoiceDateArr,
      ...displayDueDateArr,
      ...daysArr,
      ...maxDaysArr,
      ...totArr,
    ];
  }

  const handleRangeChangeByTotalCount = (from, to, index) => {
    let updatedTableArr = [...tableCell];
    let updatedFromToArr = [...fromToArr];

    let updatedRows = [...rowsByTotalCount];
    let maxToDay = Math.max(...updatedFromToArr.map((ele) => Number(ele.to)));
    const oldFrom = updatedTableArr[index].fromDay;
    const oldTo = updatedTableArr[index].toDay;

    let newFromDay = from === '' ? 0 : Number(from);
    let newToDay = to === '' ? 0 : Number(to);
    const fromChanged = newFromDay !== oldFrom;
    const toChanged = newToDay !== oldTo;

    if (newFromDay >= newToDay) {
      // setWarningSnakbar(true);
      // showWarningSnackbar('From Day must be earlier than  To day');
      return;
    }
    const isDuplicate = updatedFromToArr.some((range) => range.from === newFromDay && range.to === newToDay);

    if (isDuplicate) {
      // setWarningSnakbar(true);
      // showWarningSnackbar('This range already exists');
      return;
    }

    updatedTableArr[index] = {
      ...updatedTableArr[index],
      fromDay: newFromDay,
      toDay: newToDay,
      id: `${newFromDay} - ${newToDay} Days`,
      label: `${newFromDay} - ${newToDay} Days`,
      diffday: newToDay - newFromDay,
    };

    updatedFromToArr[index - 5] = {
      ...updatedFromToArr[index - 5],
      from: newFromDay,
      to: newToDay,
    };

    // Build daysArr from updatedTableArr to ensure all ranges are included
    let daysArr = [];
    updatedTableArr?.forEach((ele) => {
      // Only include range columns (those with fromDay, toDay, and icon: true)
      if (ele.fromDay !== '' && ele.toDay !== '' && ele.icon === true) {
        daysArr.push({
          id: ele.fromDay + ' ' + '-' + ' ' + ele.toDay + ' ' + 'Days',
          label: ele.fromDay + ' ' + '-' + ' ' + ele.toDay + ' ' + 'Days',
          minWidth: '80px',
          fromDay: ele.fromDay,
          toDay: ele.toDay,
          diffday: Number(ele.toDay) - Number(ele.fromDay),
          icon: true,
        });
      }
    });
    // Sort daysArr by fromDay to ensure proper order
    // daysArr = daysArr.sort((a, b) => Number(a.fromDay) - Number(b.fromDay));
    const overlapExists = hasOverlap(
  daysArr.map((d) => ({ from: d.fromDay, to: d.toDay }))
);

if (!overlapExists) {
  daysArr = daysArr.sort((a, b) => Number(a.fromDay) - Number(b.fromDay));
}


    // Synchronize updatedFromToArr with updatedTableArr to keep them in sync
    updatedFromToArr = daysArr.map((ele) => ({
      from: ele.fromDay,
      to: ele.toDay,
    }));

    maxToDay = Math.max(...daysArr.map((ele) => Number(ele.toDay)));

    let totBalanceDueAmount = 0;

    let startNo = 0;
    let endNo = 0;
    let arrOfBalancDue = [];
    updatedRows?.map((col) => {
      col.amtArr = [];
      col.newAmtArr = [];
      daysArr?.map((ele) => {
        col.amtArr.push({
          label: ele.fromDay + ' ' + '-' + ' ' + ele.toDay + ' ' + 'Days',
          amount: col.dueDays >= ele.fromDay && col.dueDays <= ele.toDay ? Number(col?.balancedueamount).toFixed(2) : 0,
        });

        startNo = ele.fromDay;
        endNo = ele.toDay;
        if (col.dueDays >= startNo && col.dueDays <= endNo) {
          arrOfBalancDue.push({
            label: startNo + ' ' + '-' + ' ' + endNo + ' ' + 'Days',
            amount: col.balancedueamount,
          });
        } else {
          arrOfBalancDue.push({
            label: startNo + ' ' + '-' + ' ' + endNo + ' ' + 'Days',
            amount: 0,
          });
        }
      });
      col.amtArr.map((ele) => {
        totBalanceDueAmount += Number(ele.amount);
      });
    });

    const uniqueIds = [];
    let tempArray = [];
    arrOfBalancDue.forEach((element) => {
      const label = element.label;
      const amt = Number(element.amount || 0);

      if (!uniqueIds.includes(label)) {
        uniqueIds.push(label);
        tempArray.push({
          period: label,
          balanceDueAmt: parseToCents(amt),
        });
      } else {
        tempArray.forEach((item) => {
          if (item.period === label) {
            const prevCents = item.balanceDueAmt;
            const newCents = parseToCents(amt);
            item.balanceDueAmt = prevCents + newCents;
          }
        });
      }
    });

    const finalTempArray = tempArray.map((x) => ({
      period: x.period,
      balanceDueAmt: formatFromCents(x.balanceDueAmt), // ALWAYS 2 decimals
    }));

    setRowTotalBalanceDueByCount(finalTempArray);
    let newRows = [];
    updatedRows.map((ele) => {
      newRows.push({
        PartyName: ele?.partylegalname,
        InvoiceNumber: ele?.voucherNo,
        InvoiceDate: ele?.invoiceDate,
        DueDate: ele?.dueDate,
        arr: ele.amtArr,
        maxDaysBalanceAmt: ele?.dueDays > maxToDay ? Number(ele?.balancedueamount) : 0,
        totalCount: ele?.totalCount,
      });
    });

    const uniqueIdsArr = [];
    let tempArrayArr = [];
    const uniqueArr = newRows.filter((element) => {
      const isDuplicateArr = uniqueIdsArr.includes(element.InvoiceNumber);
      if (!isDuplicateArr) {
        uniqueIdsArr.push(element.InvoiceNumber);
        tempArrayArr.push({
          PartyName: element.PartyName,
          InvoiceNumber: element.InvoiceNumber,
          InvoiceDate: element?.InvoiceDate,
          DueDate: element?.DueDate,
          arr: element.arr,
          maxDaysBalanceAmt: element?.maxDaysBalanceAmt,
          totalCount: element?.totalCount,
        });
        return true;
      } else {
        tempArrayArr.map((item) => {
          if (element.InvoiceNumber === item.InvoiceNumber) {
            item.arr = [...item.arr, ...element.arr];
          }
        });
      }
      return false;
    });

    tempArrayArr.map((ele) => {
      const uniqueIds = [];
      let tempArray = [];
      const unique = ele.arr.filter((element) => {
        const isDuplicate = uniqueIds.includes(element.label);
        if (!isDuplicate) {
          uniqueIds.push(element.label);
          tempArray.push({
            period: element.label,
            balanceDueAmt: element.amount,
          });
          return true;
        } else {
          tempArray.map((item) => {
            if (element.label === item.period) {
              item.balanceDueAmt = Number(element.amount) + Number(item.balanceDueAmt);
            }
          });
        }
        return false;
      });
      ele.arr = tempArray;
    });

    let maxDaysCents = 0n;
    tempArrayArr.forEach((item) => {
      if (item.maxDaysBalanceAmt !== 0 && item.maxDaysBalanceAmt !== '0') {
        maxDaysCents += parseToCents(item.maxDaysBalanceAmt);
      }
    });
    const maxDaysTotalStr = formatFromCents(maxDaysCents);
    setMaxDaysTotalByCount(maxDaysTotalStr);

    const totalCents1 = parseToCents(totBalanceDueAmount);
    const totalCents2 = maxDaysCents;
    const grandTotalCents = totalCents1 + totalCents2;
    const grandTotalStr = formatFromCents(grandTotalCents); // Already ensures exactly 2 decimals
    let ageingBalance = 0;
    ageingBalance = Number(totalNetAmt) - Number(grandTotalStr);
    setAgeingBalance(ageingBalance);
    setTotalAmtByTotalCount(grandTotalStr);
  };
  const addNewCell = () => {
    // if (enableEdit) {
    //   showWarningSnackbar('Please update the existing ageing range before adding a new age.');
    //   return;
    // }
    setEnableEdit(true);
    setAddCell(true);
    setTimeout(() => {
      const element = document.getElementById('sheduleFrom');
      element?.focus();
    }, 0);
  };

  const validateAndUpdateAllRanges = () => {
    let hasError = false;
    const updatedTableArr = [...tableCell];
    const currentFromToArr = [...fromToArr];

    // Get all ageing columns (icon === true)
    const ageingColumns = tableCell.map((col, idx) => ({ ...col, originalIndex: idx })).filter((col) => col.icon === true);

    // Sort the ageing columns by the 'fromDay' to ensure correct sequence
    ageingColumns.sort((a, b) => Number(a.fromDay) - Number(b.fromDay));

    // --- Track all validation errors ---
    const gapMessages = new Set();
    const gapFromIndexes = new Set();
    const gapToIndexes = new Set();
    const validationErrorFromIndexes = new Set();
    const validationErrorToIndexes = new Set();

    // --- Gap detection (used to highlight the specific ageing header cells) ---
    if (ageingColumns.length > 0) {
      const firstRangeStart = Number(ageingColumns[0]?.fromDay || 0);
      if (firstRangeStart > 0) {
        const gapStart = 0;
        const gapEnd = firstRangeStart - 1;
        // Handle single day gap vs multiple days gap
        const gapMessage = gapStart === gapEnd 
          ? `${gapStart} days` 
          : `${gapStart} - ${gapEnd} days`;
        gapMessages.add(gapMessage);
        // gap before the first range => mark first range FROM value
        gapFromIndexes.add(ageingColumns[0].originalIndex);
        validationErrorFromIndexes.add(ageingColumns[0].originalIndex);
        hasError = true;
      }
      for (let j = 0; j < ageingColumns.length - 1; j++) {
        const currentRangeEnd = Number(ageingColumns[j]?.toDay || 0);
        const nextRangeStart = Number(ageingColumns[j + 1]?.fromDay || 0);
        if (nextRangeStart > currentRangeEnd + 1) {
          const gapStart = currentRangeEnd + 1;
          const gapEnd = nextRangeStart - 1;
          // Handle single day gap vs multiple days gap
          const gapMessage = gapStart === gapEnd 
            ? `${gapStart} days` 
            : `${gapStart} - ${gapEnd} days`;
          gapMessages.add(gapMessage);
          // mark ONLY the boundary values:
          // previous bucket TO and next bucket FROM
          gapToIndexes.add(ageingColumns[j].originalIndex);
          gapFromIndexes.add(ageingColumns[j + 1].originalIndex);
          validationErrorToIndexes.add(ageingColumns[j].originalIndex);
          validationErrorFromIndexes.add(ageingColumns[j + 1].originalIndex);
          hasError = true;
        }
      }
    }

    // Validate each ageing column
    if (Number(ageingBalance) > 0) {
      showWarningSnackbar(
        `The ageing schedule cannot be updated because the ageing balance does not match the total outstanding balance. The difference is ₹${MoneyFormatv3(
          ageingBalance
        )}.`
      );
      hasError = true;
      // Mark all ageing columns with red borders when balance mismatch
      ageingColumns.forEach((col) => {
        validationErrorFromIndexes.add(col.originalIndex);
        validationErrorToIndexes.add(col.originalIndex);
      });
    }

    // Validate each ageing column (duplicates/overlaps/etc.)
    // First, collect all overlap errors with their overlap counts
    const overlapErrorCounts = new Map(); // Map of index -> overlap count
    let overlapWarningText = '';

    for (let i = 0; i < ageingColumns.length; i++) {
      const col = ageingColumns[i];
      const ind = col.originalIndex;
      const currentFrom = Number(col.fromDay || 0);
      const currentTo = Number(col.toDay || 0);

      // Check if first range starts at 0
      const prevFrom = currentFromToArr[ind - 5]?.from;
      if (prevFrom === 0 && currentFrom === 1) {
        showWarningSnackbar('The earliest ageing range must begin at 0. Please enter a valid starting day.');
        hasError = true;
        validationErrorFromIndexes.add(ind);
        updatedTableArr[ind].fromDay = prevFrom;
        setTableCell(updatedTableArr);
        continue;
      }

      // Basic validation: From must be less than To
      if (currentTo <= currentFrom) {
        showWarningSnackbar('From Day must be earlier than To Day');
        validationErrorFromIndexes.add(ind);
        validationErrorToIndexes.add(ind);
        hasError = true;
        // Set validation markers state with ONLY this column's error before returning
        // Clear any previous errors and only show this specific error
        setShowValidationMarkers(true);
        setValidationErrorFromIndexes([ind]);
        setValidationErrorToIndexes([ind]);
        return;
      }
      if (currentFrom >= currentTo) {
        showWarningSnackbar('From Day must be earlier than To Day');
        validationErrorFromIndexes.add(ind);
        validationErrorToIndexes.add(ind);
        hasError = true;
        // Set validation markers state with ONLY this column's error before returning
        // Clear any previous errors and only show this specific error
        setShowValidationMarkers(true);
        setValidationErrorFromIndexes([ind]);
        setValidationErrorToIndexes([ind]);
        return;
      }

      // Check for duplicates and overlaps with other ranges
      let warningText = '';
      let overlapCount = 0;
      const otherRanges = ageingColumns
        .filter((otherCol, otherIdx) => otherIdx !== i)
        .map((otherCol) => ({
          from: Number(otherCol.fromDay || 0),
          to: Number(otherCol.toDay || 0),
        }));

      otherRanges.forEach((range) => {
        const existingFrom = Number(range.from);
        const existingTo = Number(range.to);
        let isOverlap = false;

        // Check for exact duplicate
        if (existingFrom === currentFrom && existingTo === currentTo) {
          warningText = 'This range already exists';
          isOverlap = true;
        }
        // Check if current range completely contains existing range
        else if (currentFrom < existingFrom && currentTo > existingTo) {
          warningText = 'The selected range overlaps with an existing period';
          isOverlap = true;
        }
        // Check if existing range completely contains current range
        else if (existingFrom < currentFrom && existingTo > currentTo) {
          warningText = 'The selected range overlaps with an existing period';
          isOverlap = true;
        }
        // Check if current range starts within existing range
        else if (currentFrom >= existingFrom && currentFrom < existingTo) {
          warningText = 'The selected range overlaps with an existing period';
          isOverlap = true;
        }
        // Check if current range ends within existing range
        else if (currentTo > existingFrom && currentTo <= existingTo) {
          warningText = 'The selected range overlaps with an existing period';
          isOverlap = true;
        }
        // Check if ranges are adjacent (touching)
        else if (currentFrom === existingTo || currentTo === existingFrom) {
          warningText = 'The selected range overlaps with an existing period';
          isOverlap = true;
        }
        // General overlap check
        else {
          const isOverlapCheck = !(currentTo <= existingFrom || currentFrom >= existingTo);
          if (isOverlapCheck) {
            warningText = 'The selected range overlaps with an existing period';
            isOverlap = true;
          }
        }

        if (isOverlap) {
          overlapCount++;
        }
      });

      if (overlapCount > 0) {
        overlapErrorCounts.set(ind, overlapCount);
        if (!overlapWarningText) {
          overlapWarningText = warningText;
        }
        hasError = true;
      }
    }

    // If there are overlap errors, find the range with the most overlaps and mark only that one
    if (overlapErrorCounts.size > 0) {
      showWarningSnackbar(overlapWarningText || 'The selected range overlaps with an existing period');
      // Find the index with the maximum overlap count
      let maxOverlapCount = 0;
      let maxOverlapIndex = null;
      overlapErrorCounts.forEach((count, index) => {
        if (count > maxOverlapCount) {
          maxOverlapCount = count;
          maxOverlapIndex = index;
        }
      });
      // Mark only the range with the most overlaps (the problematic one)
      if (maxOverlapIndex !== null) {
        setShowValidationMarkers(true);
        setValidationErrorFromIndexes([maxOverlapIndex]);
        setValidationErrorToIndexes([maxOverlapIndex]);
        // Return early to prevent other validation code from overwriting overlap markers
        return false;
      }
    }

    // Show all gaps in a single warning message if there are any
    if (gapMessages.size > 0) {
      setShowAgeingGapMarkers(true);
      setAgeingGapFromIndexes(Array.from(gapFromIndexes));
      setAgeingGapToIndexes(Array.from(gapToIndexes));
      
      const gapMessagesArray = Array.from(gapMessages);
      let gapMessageText = '';
      
      // Check if all gaps are single day gaps
      const allSingleDayGaps = gapMessagesArray.every(msg => msg.includes('days') && !msg.includes(' - '));
      const isMultipleGaps = gapMessagesArray.length > 1;
      const rangeWord = isMultipleGaps ? 'ranges' : 'range';
      
      if (gapMessagesArray.length === 1) {
        // Single gap - check if it's a single day
        const gapMsg = gapMessagesArray[0];
        if (gapMsg.includes('days') && !gapMsg.includes(' - ')) {
          // Single day gap (e.g., "91 days")
          gapMessageText = `The ageing schedule cannot be updated because there is a gap at ${gapMsg}.`;
        } else {
          // Multiple days gap (e.g., "31 - 60 days")
          gapMessageText = `The ageing schedule cannot be updated because there is a gap in the following ${rangeWord}: ${gapMsg}.`;
        }
      } else if (allSingleDayGaps) {
        // Multiple single day gaps (e.g., "31 days, 91 days")
        gapMessageText = `The ageing schedule cannot be updated because there are gaps at the following days: ${gapMessagesArray.join(', ')}.`;
      } else {
        // Multiple gaps with mixed types
        gapMessageText = `The ageing schedule cannot be updated because there are gaps in the following ${rangeWord}: ${gapMessagesArray.join(', ')}.`;
      }
      
      showWarningSnackbar(gapMessageText);
    } else {
      // No gaps found on this Update click → clear any previous highlighting
      setShowAgeingGapMarkers(false);
      setAgeingGapFromIndexes([]);
      setAgeingGapToIndexes([]);
    }

    // Set validation error markers for all errors (gap/balance errors, not overlap errors)
    if (validationErrorFromIndexes.size > 0 || validationErrorToIndexes.size > 0) {
      setShowValidationMarkers(true);
      setValidationErrorFromIndexes(Array.from(validationErrorFromIndexes));
      setValidationErrorToIndexes(Array.from(validationErrorToIndexes));
    } else {
      // Only clear if we haven't already set overlap markers above
      if (overlapErrorCounts.size === 0) {
        setShowValidationMarkers(false);
        setValidationErrorFromIndexes([]);
        setValidationErrorToIndexes([]);
      }
    }

    // If no errors, update all ranges
    if (!hasError) {
      setShowAgeingGapMarkers(false);
      setAgeingGapFromIndexes([]);
      setAgeingGapToIndexes([]);
      setShowValidationMarkers(false);
      setValidationErrorFromIndexes([]);
      setValidationErrorToIndexes([]);
      ageingColumns.forEach((col) => {
        const ind = col.originalIndex;
        const currentFrom = Number(col.fromDay || 0);
        const currentTo = Number(col.toDay || 0);

        handleRangeChange(currentFrom, currentTo, ind);
        handleRangeChangeByTotalCount(currentFrom, currentTo, ind);
      });
      let ageingBucket = [];

      // Extract the numeric range and convert it to an object with from and to
      ageingColumns.map((age) => {
        ageingBucket.push({ from: age?.fromDay, to: age?.toDay }); // Convert to { from: number, to: number }
      });
      saveSelectedAgeing(ageingBucket);
      setEditRow(null);
      return true;
    }

    return false;
  };

  async function saveSelectedAgeing(ageingBucket) {
    const userPreferenceData = {
      additionalvalue: JSON.stringify(ageingBucket), // Pass the array as a JSON string
      attributetypecd: 'SelectedAgeing',
      attributevalue: userPreferece?.financialYear?.financialyearid,
    };

    try {
      const resUserPreferenceData = await API.graphql(
        graphqlOperation(createCompanyPreference, {
          createCompanyPreferenceInput: userPreferenceData,
        })
      );
      dispatch(companyPreferenceApi.util.invalidateTags?.(['listCompanyPreference']));
    } catch (error) {
      console.error('Error saving user preference:', error);
    }
  }

  return (
    <Box
      sx={{
        marginTop: { xs: '20px', sm: '0px' },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        
        <Box
          sx={{
            width: '100%',
            overflow: 'hidden',
          }}
        >
          {/* Header with Title + Add New Age button */}
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between', // left and right alignment
              alignItems: 'center',
              m: 1,
            }}
          >
            {/* Left side: Title + Add New Age */}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Typography sx={{ fontWeight: 600, fontSize: { xs: '11px', sm: '16px' } }}>{tableName}</Typography>
              {rows?.length > 0 && (
                <Button
                  variant="contained"
                  endIcon={<Add />}
                  size="small"
                  sx={{
                    minHeight: '32px',
                    padding: '4px 12px',
                    backgroundColor: '#D91C80',
                    '&:hover': {
                      backgroundColor: '#C01772',
                    },
                  }}
                  onClick={addNewCell}
                >
                  Add New Age
                </Button>
              )}

              
                
                  <Box
                   sx={{
  display: 'flex',
  alignItems: 'center',
  width: '240px',
  height: '32px',
  ml: 2,
  whiteSpace: 'nowrap',
  visibility: addCell ? 'visible' : 'hidden',
  pointerEvents: addCell ? 'auto' : 'none',
  opacity: addCell ? 1 : 0,
  transition: 'opacity 120ms ease',
}}

                  >
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '1px',
                        width: '100%',
                      }} // Set editRow on click
                    >
                      <TextField
                        type="text"
                        size="small"
                        id="sheduleFrom"
                        value={ageingShedule.sheduleFrom}
                        className="Input_Amount"
                        onChange={(e) => {
                          let value = e.target.value;

                          //  Allow only digits
                          if (!/^\d*$/.test(value)) return;

                          //  Remove leading zero when user types new value
                          if (value.length > 1 && value.startsWith('0')) {
                            value = value.replace(/^0+/, '');
                          }

                          const numericValue = Number(value);

                          //  Limit validation
                          if (value?.length > 3) {
                            // setWarningSnakbar(true);
                            showWarningSnackbar('Date range exceeds the allowed limit');
                            return;
                          }

                          //  Update ageing schedule
                          setAgeingShedule((prev) => ({
                            ...prev,
                            sheduleFrom: value,
                          }));
                        }}
                        sx={{
                          minWidth: '50px',
                          width: 'auto',
                          // maxWidth: '120px',
                          textAlign: 'center',
                          '& .MuiInputBase-input': {
                            textAlign: 'center',
                            // color: '#FFF',
                            color: '#292828d1',
                            fontWeight: 700,
                          },
                          // '& fieldset': {
                          //   border: '1px solid white !important',
                          // },
                        }}
                        inputProps={{
                          style: {
                            minWidth: '4ch', // minimum width for 4 characters
                            // width: `${(column?.toDay?.toString().length || 1) * 6}px`, // expand per char
                          },
                        }}
                      />

                      <Box
                        sx={{
                          mx: '1px',
                          //  color: '#FFF'
                        }}
                      >
                        {' '}
                        -{' '}
                      </Box>

                      <TextField
                        type="text"
                        size="small"
                        value={ageingShedule.sheduleTo}
                        className="Input_Amount"
                        onChange={(e) => {
                          let value = e.target.value;

                          //  Allow only digits
                          if (!/^\d*$/.test(value)) return;

                          //  Remove leading zeros (0, 00 → "")
                          if (value.length > 1 && value.startsWith('0')) {
                            value = value.replace(/^0+/, '');
                          }

                          const numericValue = Number(value);

                          //  Max limit check
                          if (value?.length > 3) {
                            // setWarningSnakbar(true);
                            showWarningSnackbar('Date range exceeds the allowed limit');
                            return;
                          }

                          // Update state
                          setAgeingShedule((prev) => ({
                            ...prev,
                            sheduleTo: value,
                          }));
                        }}
                        sx={{
                          minWidth: '50px',
                          width: 'auto',
                          // maxWidth: '120px',
                          textAlign: 'center',
                          '& .MuiInputBase-input': {
                            textAlign: 'center',
                            // color: '#FFF',
                            color: '#292828d1',
                            fontWeight: 700,
                          },
                          // '& fieldset': {
                          //   border: '1px solid white !important',
                          // },
                        }}
                        inputProps={{
                          style: {
                            minWidth: '4ch', // minimum width for 4 characters
                            // width: `${(column?.toDay?.toString().length || 1) * 6}px`, // expand per char
                          },
                        }}
                      />

                      <Box
                        sx={{
                          ml: '2px',
                          // color: '#FFF'
                        }}
                      >
                        {' '}
                        Days{' '}
                      </Box>
                    </Box>

                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        ml: '3px',
                        mr: '4px',
                      }}
                    >
                      <Tooltip title="Save" placement="right" disableInteractive arrow>
                        <IconButton
                          disableRipple
                          onClick={addAgeingShedule}
                          sx={{
                            margin: '0px 2px',
                            padding: '3px',
                            width: 22,
                            height: 22,
                            borderRadius: '50%',
                            border: '1.8px solid #34994f',
                          }}
                        >
                          <Done sx={{ fontSize: '13px', color: '#34994f' }} />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Cancel" placement="right" disableInteractive arrow>
                        <IconButton
                          onClick={() => {
                            setAddCell(false);
                            setAgeingShedule((prev) => ({
                              ...prev,
                              sheduleTo: '',
                              sheduleFrom: '',
                            }));
                          }}
                          disableRipple
                          sx={{
                            margin: '0px 2px',
                            padding: '3px',
                            width: 22,
                            height: 22,
                            borderRadius: '50%',
                            border: '1.8px solid #eb6a6a', // red border
                          }}
                        >
                          <CloseIcon
                            sx={{
                              fontSize: '13px', // smaller icon
                              color: '#eb6a6a', // red icon
                            }}
                          />
                        </IconButton>
                      </Tooltip>
                    </Box>
                  </Box>
                
              
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              {/* Balance info */}
              {Number(ageingBalance) > 0 && (
                <Typography sx={{ fontWeight: 600, fontSize: { xs: '11px', sm: '16px' } }}>
                  Ageing Balance Difference (Tally) : &nbsp;
                  <span style={{ color: '#d32f2f' }}>₹ {MoneyFormatv3(ageingBalance)}</span>
                </Typography>
              )}

              {/* Enable / Update button */}
              {rows?.length > 0 && (
                <Button
                  variant="contained"
                  endIcon={
                    !enableEdit ? (
                      <EditIcon />
                    ) : (
                      //  <UpdateIcon />
                      ''
                    )
                  }
                  size="small"
                  sx={{
                    background: !enableEdit ? '#D91C80 100%' : '#ee5b2b',
                    '&:hover': {
                      background: !enableEdit ? '#D91C80 100%' : '#ee5b2b',
                    },
                    minHeight: '32px',
                    padding: '4px 12px',
                    whiteSpace: 'nowrap',
                  }}
                  onClick={() => {
                    if (enableEdit) {
                      const isValid = validateAndUpdateAllRanges();
                      if (isValid) {
                        setEnableEdit(false);
                        setShowAgeingGapMarkers(false);
                        setAgeingGapFromIndexes([]);
                        setAgeingGapToIndexes([]);
                        setShowValidationMarkers(false);
                        setValidationErrorFromIndexes([]);
                        setValidationErrorToIndexes([]);
                        showSuccessSnackbar('Ageing updated Successfully');
                      }
                    } else {
                      setEnableEdit(true);
                      // Clear any existing validation markers when enabling edit
                      setShowValidationMarkers(false);
                      setValidationErrorFromIndexes([]);
                      setValidationErrorToIndexes([]);
                      setShowAgeingGapMarkers(false);
                      setAgeingGapFromIndexes([]);
                      setAgeingGapToIndexes([]);
                    }
                  }}
                >
                  {enableEdit ? 'Update' : 'Enable Edit'}
                </Button>
              )}
            </Box>
          </Box>

          {/* {fromToArr.length > 0 && ( */}
          <>
            <TableContainer
              sx={{
                m: 1,
                '::-webkit-scrollbar': {
                  width: 14,
                },
                '::-webkit-scrollbar-track': {
                  // background: "#f1f1f1",
                },
                '::-webkit-scrollbar-thumb': {
                  background: 'primary.main',
                },
                maxHeight: 500,
              }}
            >
              <Table stickyHeader sx={{ minWidth: '1500px', tableLayout: 'auto' }} className={classes.table} aria-label="sticky table">
                <TableHead sx={{ color: theme.palette.secondary.main }}>
                  <TableRow
                    className="EnabeleTableCellBorder"
                    sx={{
                      '& .MuiTableCell-root': {
                        paddingTop: '0.01px !important',
                        paddingBottom: '0.01px !important',
                        lineHeight: '0.1px !important',
                        fontSize: '0.80rem !important',
                      },
                    }}
                  >
                    {tableCell.map((column, ind) => {
                      const isGapFrom = showAgeingGapMarkers && ageingGapFromIndexes.includes(ind);
                      const isGapTo = showAgeingGapMarkers && ageingGapToIndexes.includes(ind);
                      const isValidationErrorFrom = showValidationMarkers && validationErrorFromIndexes.includes(ind);
                      const isValidationErrorTo = showValidationMarkers && validationErrorToIndexes.includes(ind);
                      // Show red if it's a gap marker OR any validation error
                      const hasFromError = isGapFrom || isValidationErrorFrom;
                      const hasToError = isGapTo || isValidationErrorTo;
                      const fromColor = hasFromError ? '#d32f2f' : '#292828d1';
                      const toColor = hasToError ? '#d32f2f' : '#292828d1';
                      const fromBorderColor = hasFromError ? '#d32f2f' : enableEdit ? '#FFF' : 'transparent';
                      const toBorderColor = hasToError ? '#d32f2f' : enableEdit ? '#FFF' : 'transparent';
                      return column?.icon === true ? (
                        <TableCell
                          key={ind}
                          sx={{
                            whiteSpace: 'nowrap',
                            width: 'fit-content',
                            backgroundColor: '#E6CED7 !important',
                            color: '#FFF',
                            textAlign: 'center',
                            padding: '4px 6px',
                            position: 'sticky',
                          }}
                        >
                          {/* DELETE ICON - Top Right Corner of Column */}
                          {enableEdit && (
                            <Tooltip title="Delete" placement="top" disableInteractive arrow>
                              <IconButton
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleAgeingClose(ind);
                                }}
                                sx={{
                                  position: 'absolute',
                                  top: 3,
                                  left: '50%',
                                  transform: 'translate(-50%, -50%)',
                                  padding: '2px',
                                  width: '18px',
                                  height: '18px',
                                  border: '1px solid #FFF',
                                  borderRadius: '50%',
                                  backgroundColor: '#FFF',
                                  zIndex: 20,
                                  '&:hover': {
                                    backgroundColor: '#FFF',
                                  },
                                }}
                              >
                                <Delete
                                  sx={{
                                    fontSize: '10px',
                                    color: '#d32f2f',
                                    '&:hover': {
                                      color: '#c62828',
                                    },
                                  }}
                                />
                              </IconButton>
                            </Tooltip>
                          )}
                          <Box
                            sx={{
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'center',
                              justifyContent: 'center',
                              backgroundColor: '#E6CED7 !important',
                              gap: '2px',
                            }}
                          >
                            {/* FROM - TO INPUT ROW */}
                            <Box
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: '4px',
                              }}
                              onClick={() => setEditRow(ind)}
                            >
                              <TextField
                                type="text"
                                size="small"
                                id="fromDay"
                                value={column?.fromDay || 0}
                                // autoFocus={editRow === ind && enableEdit}
                                inputRef={(el) => (fromDayRefs.current[ind] = el)}
                                disabled={!enableEdit}
                                onChange={(e) => {
                                  let value = e.target.value;
                                  if (!/^\d*$/.test(value)) {
                                    return;
                                  }
                                  // Remove leading zero when editing initial value
                                  if (value.length > 1 && value.startsWith('0')) {
                                    value = value.replace(/^0+/, '');
                                  }

                                  // Convert to number safely
                                  const numericValue = Number(value);

                                  // Max limit check
                                  if (value?.length > 3) {
                                    showWarningSnackbar('Date range exceeds the allowed limit');
                                    return;
                                  }

                                  const updatedTableArr = [...tableCell];
                                  updatedTableArr[ind] = { ...updatedTableArr[ind], fromDay: value };
                                  setTableCell(updatedTableArr);
                                  // Clear gap markers and validation markers on onChange
                                  setShowAgeingGapMarkers(false);
                                  setAgeingGapFromIndexes([]);
                                  setAgeingGapToIndexes([]);
                                  setShowValidationMarkers(false);
                                  setValidationErrorFromIndexes([]);
                                  setValidationErrorToIndexes([]);
                                }}
                                onFocus={() => (lastValidFromValues.current[ind] = Number(column?.fromDay || 0))}
                                onBlur={() => {
                                  const currentFrom = Number(column?.fromDay || 0);
                                  // const lastValid = Number(lastValidFromValues.current[ind] || 0);

                                  // if (currentFrom === lastValid) return setEditRow(null);

                                  const currentTo = Number(column?.toDay || 0);

                                  const updatedFromToArr = [...fromToArr];

                                  // ✔ Valid input → update
                                  handleRangeChange(currentFrom, currentTo, ind);
                                  handleRangeChangeByTotalCount(currentFrom, currentTo, ind);

                                  setEditRow(null);
                                }}
                                sx={{
                                  width: '48px',
                                  '& .MuiInputBase-input': { textAlign: 'center', padding: '2px', color: fromColor, fontWeight: 700 },
                                  '& .MuiInputBase-input.Mui-disabled': { color: fromColor, WebkitTextFillColor: fromColor },
                                  '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
                                    borderColor: fromBorderColor,
                                    borderWidth: hasFromError ? 2 : 1,
                                  },
                                  '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
                                    borderColor: fromBorderColor,
                                  },
                                  '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                    borderColor: fromBorderColor,
                                  },
                                  '& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline': {
                                    borderColor: fromBorderColor,
                                  },
                                }}
                              />

                              <span style={{ color: '#292828d1', fontWeight: 700 }}>-</span>

                              <TextField
                                type="text"
                                size="small"
                                value={column?.toDay || 0}
                                // autoFocus={editRow === ind && enableEdit}
                                disabled={!enableEdit}
                                onChange={(e) => {
                                  let value = e.target.value;
                                  if (!/^\d*$/.test(value)) {
                                    return;
                                  }

                                  if (value.length > 1 && value.startsWith('0')) {
                                    value = value.replace(/^0+/, '');
                                  }

                                  const numericValue = Number(value);

                                  if (value?.length > 3) {
                                    showWarningSnackbar('Date range exceeds the allowed limit');
                                    return;
                                  }

                                  const updatedTableArr = [...tableCell];
                                  updatedTableArr[ind] = {
                                    ...updatedTableArr[ind],
                                    toDay: value,
                                  };
                                  setTableCell(updatedTableArr);
                                  // Clear gap markers and validation markers on onChange
                                  setShowAgeingGapMarkers(false);
                                  setAgeingGapFromIndexes([]);
                                  setAgeingGapToIndexes([]);
                                  setShowValidationMarkers(false);
                                  setValidationErrorFromIndexes([]);
                                  setValidationErrorToIndexes([]);
                                }}
                                onFocus={() => (lastValidToValues.current[ind] = Number(column?.toDay || 0))}
                                onBlur={() => {
                                  const currentFrom = Number(column?.fromDay || 0);
                                  const currentTo = Number(column?.toDay || 0);

                                  handleRangeChange(currentFrom, currentTo, ind);
                                  handleRangeChangeByTotalCount(currentFrom, currentTo, ind);
                                  setEditRow(null);
                                }}
                                sx={{
                                  width: '48px',
                                  '& .MuiInputBase-input': { textAlign: 'center', padding: '2px', color: toColor, fontWeight: 700 },
                                  '& .MuiInputBase-input.Mui-disabled': { color: toColor, WebkitTextFillColor: toColor },
                                  '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
                                    borderColor: toBorderColor,
                                    borderWidth: hasToError ? 2 : 1,
                                  },
                                  '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
                                    borderColor: toBorderColor,
                                  },
                                  '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                    borderColor: toBorderColor,
                                  },
                                  '& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline': {
                                    borderColor: toBorderColor,
                                  },
                                }}
                              />
                            </Box>

                            {/* DAYS + EDIT + CLOSE ROW */}
                            <Box
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: '4px',
                                marginTop: '5px',
                              }}
                            >
                              <Box>Days</Box>
                            </Box>
                          </Box>
                        </TableCell>
                      ) : (
                        <TableCell
                          key={ind}
                          sx={{
                            textAlign: column?.id === 'Total' ? 'right' : 'left',
                            whiteSpace: 'nowrap',
                            width: 'fit-content',
                            position: 'sticky',

                            borderRight: column?.id === 'PartyName' ? '3px solid #0000001f' : '',
                            borderLeft: column?.id === 'Total' ? '3px solid #0000001f !important' : '',

                            left: column?.id === 'SL.No' ? '0px' : column?.id === 'PartyName' ? '70px' : undefined,

                            right: column?.id === 'Total' ? 0 : undefined,

                            backgroundColor: ['SL.No', 'PartyName', 'Total', 'maxToDay'].includes(column?.id)
                              ? theme?.palette?.TmId.id.toString().includes('9')
                                ? 'black'
                                : '#E6CED7 !important'
                              : '#E6CED7 !important',

                            zIndex: ['SL.No', 'PartyName', 'Total'].includes(column?.id) ? 1200 : 'auto',

                            p: 0,
                          }}
                        >
                          {column?.id === 'maxToDay' ? (
                            <Box
                              sx={{
                                display: 'flex',
                                alignItems: 'stretch',
                                height: '100%',
                                width: '100%',
                              }}
                            >
                              <Divider
                                orientation="vertical"
                                flexItem
                                sx={{
                                  borderRightWidth: 1,
                                  height: '65px',
                                  borderColor: addCell ? '#0000001f' : 'transparent', // ← invisible when false
                                  opacity: addCell ? 1 : 0, // ← hide only the line
                                }}
                              />
                              <Box sx={{ flex: addCell === true ? 3 : 1, display: 'flex', alignItems: 'center', px: 1.5 }}>
                                <Typography sx={{ fontWeight: 'bold' }}>{column.label}</Typography>
                              </Box>
                            </Box>
                          ) : (
                            <Typography sx={{ fontWeight: 'bold', px: 1.5 }}>{column.label}</Typography>
                          )}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                </TableHead>
                {filterData.length > 0 ? (
                  <TableBody>
                    {filterData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((col, ind) => {
                      let totBalanceDueAmount = 0;

                      const isItemSelected = isSelected(page * rowsPerPage + (ind + 1));
                      const labelId = `enhanced-table-checkbox-${ind}`;

                      col?.arr.map((ele) => {
                        totBalanceDueAmount += Number(ele?.balanceDueAmt);
                      });
                      totBalanceDueAmount = Number(totBalanceDueAmount) + Number(col?.maxDaysBalanceAmt);

                      return (
                        <TableRow
                          key={page * rowsPerPage + (ind + 1)}
                          sx={{
                            '& .MuiTableCell-root': {
                              paddingTop: '4px !important',
                              paddingBottom: '4px !important',
                              lineHeight: '10x',
                              fontSize: '0.80rem',
                            },
                          }}
                        >
                          <TableCell
                            sx={{
                              // width: "30px",
                              width: 'fit-content',
                              position: 'sticky',
                              left: 0,
                              // zIndex:1100,
                              backgroundColor: theme?.palette?.TmId.id.toString().includes('9') ? 'black' : 'white',
                              color: theme?.palette?.TmId.id.toString().includes('9') ? 'white' : 'black',
                            }}
                          >
                            {page * rowsPerPage + (ind + 1)}
                          </TableCell>
                          <TableCell
                            sx={{
                              whiteSpace: 'nowrap',
                              // minWidth: '150px', // Adjust as needed
                              width: 'fit-content',
                              position: 'sticky',
                              left: '70px',
                              // zIndex:1100,
                              backgroundColor: theme?.palette?.TmId.id.toString().includes('9') ? 'black' : 'white',
                              color: theme?.palette?.TmId.id.toString().includes('9') ? 'white' : 'black',
                              borderRight: '3px solid #0000001f',
                            }}
                          >
                            {col?.PartyName}
                          </TableCell>
                          <TableCell
                            sx={{
                              whiteSpace: 'nowrap',
                              // minWidth: '150px', // Adjust as needed
                              // width: '100%',
                              width: 'fit-content',
                              // position: { xs: 'static', md: 'sticky' },
                              // left: '250px',
                              // zIndex:1100,
                              backgroundColor: theme?.palette?.TmId.id.toString().includes('9') ? 'black' : 'white',
                              color: theme?.palette?.TmId.id.toString().includes('9') ? 'white' : 'black',
                            }}
                          >
                            {col?.InvoiceNumber}
                          </TableCell>
                          <TableCell
                            sx={{
                              whiteSpace: 'nowrap',

                              // width: '100%',
                              width: 'fit-content',

                              backgroundColor: theme?.palette?.TmId.id.toString().includes('9') ? 'black' : 'white',
                              color: theme?.palette?.TmId.id.toString().includes('9') ? 'white' : 'black',
                            }}
                          >
                            {col?.InvoiceDate}
                          </TableCell>
                          <TableCell
                            sx={{
                              whiteSpace: 'nowrap',

                              // width: '100%',
                              width: 'fit-content',

                              backgroundColor: theme?.palette?.TmId.id.toString().includes('9') ? 'black' : 'white',
                              color: theme?.palette?.TmId.id.toString().includes('9') ? 'white' : 'black',
                            }}
                          >
                            {col?.DueDate}
                          </TableCell>

                          {col.arr.map((ele) => {
                            return (
                              <TableCell
                                sx={{
                                  // maxWidth: '140px',
                                  // width: '100%',
                                  width: 'fit-content',
                                  backgroundColor: theme?.palette?.TmId.id.toString().includes('9') ? 'black' : 'white',
                                  color: theme?.palette?.TmId.id.toString().includes('9') ? 'white' : 'black',
                                }}
                                align="right"
                              >
                                ₹ {ele?.balanceDueAmt == 0 ? '0.00' : format(Number(ele?.balanceDueAmt))}
                              </TableCell>
                            );
                          })}
                          <TableCell
                            sx={{
                              // minWidth: '120px',
                              // width: '100%',
                              width: 'fit-content',
                              backgroundColor: theme?.palette?.TmId.id.toString().includes('9') ? 'black' : 'white',
                              color: theme?.palette?.TmId.id.toString().includes('9') ? 'white' : 'black',
                            }}
                            align="right"
                          >
                            ₹ {col?.maxDaysBalanceAmt == 0 ? '0.00' : format(Number(col?.maxDaysBalanceAmt))}
                          </TableCell>
                          <TableCell
                            sx={{
                              position: 'sticky',
                              // minWidth: '120px',
                              // width: '100%',
                              width: 'fit-content',
                              right: 0,
                              backgroundColor: theme?.palette?.TmId.id.toString().includes('9') ? 'black' : 'white',
                              color: theme?.palette?.TmId.id.toString().includes('9') ? 'white' : 'black',
                              borderLeft: '3px solid #0000001f !important',
                            }}
                            align="right"
                          >
                            ₹{totBalanceDueAmount == 0 ? '0.00' : format(Number(totBalanceDueAmount))}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                    <TableRow
                      sx={{
                        position: 'sticky',
                        bottom: 0,
                        zIndex: 1200,
                        backgroundColor: theme?.palette?.TmId.id.toString().includes('9') ? 'black' : 'white',
                        color: theme?.palette?.TmId.id.toString().includes('9') ? 'white' : 'black',
                        '& .MuiTableCell-root': {
                          paddingTop: '4px !important',
                          paddingBottom: '4px !important',
                          lineHeight: '10x',
                          fontSize: '0.80rem',
                        },
                      }}
                    >
                      <TableCell
                        sx={{
                          // maxWidth: '40px',
                          // width: '30px',
                          width: 'fit-content',
                          fontWeight: 'bold',
                          position: 'sticky',
                          left: 0,
                          backgroundColor: theme?.palette?.TmId.id.toString().includes('9') ? 'black' : 'white',
                          color: theme?.palette?.TmId.id.toString().includes('9') ? 'white' : 'black',
                          zIndex: 1100,
                          borderRight: 'none !important',
                        }}
                      ></TableCell>
                      <TableCell
                        sx={{
                          position: 'sticky',
                          left: '70px',
                          backgroundColor: theme?.palette?.TmId.id.toString().includes('9') ? 'black' : 'white',
                          color: theme?.palette?.TmId.id.toString().includes('9') ? 'white' : 'black',
                          zIndex: 1100,
                          fontWeight: 'bold',
                          width: 'fit-content',

                          borderRight: '3px solid #0000001f',
                        }}
                        align="right"
                      >
                        {' '}
                        Grand Total
                      </TableCell>
                      <TableCell
                        sx={{
                          backgroundColor: theme?.palette?.TmId.id.toString().includes('9') ? 'black' : 'white',
                          color: theme?.palette?.TmId.id.toString().includes('9') ? 'white' : 'black',
                          zIndex: 1100,
                          border: 'none !important',
                        }}
                      ></TableCell>
                      <TableCell
                        sx={{
                          // position: { xs: 'static', md: 'sticky' },
                          // left: '360px',
                          // width: '100%',
                          width: 'fit-content',
                          backgroundColor: theme?.palette?.TmId.id.toString().includes('9') ? 'black' : 'white',
                          color: theme?.palette?.TmId.id.toString().includes('9') ? 'white' : 'black',
                          zIndex: 1100,
                          border: 'none !important',
                        }}
                      ></TableCell>
                      <TableCell
                        sx={{
                          // position: 'sticky' ,
                          left: '480px',
                          backgroundColor: theme?.palette?.TmId.id.toString().includes('9') ? 'black' : 'white',
                          color: theme?.palette?.TmId.id.toString().includes('9') ? 'white' : 'black',
                          // borderRight: '3px solid #CCC', // Ensure the row does not overlap with content
                          zIndex: 1100,
                          fontWeight: 'bold',
                          borderLeft: 'none !important',
                          // width: '100%',
                          width: 'fit-content',
                        }}
                      ></TableCell>

                      {rowTotalBalanceDueByCount.map((ele) => {
                        return (
                          <TableCell
                            sx={{
                              whiteSpace: 'nowrap',
                              // minWidth: '150px', // Adjust as needed
                              // width: '100%',
                              width: 'fit-content',
                              fontWeight: 'bold',
                              backgroundColor: theme?.palette?.TmId.id.toString().includes('9') ? 'black' : 'white',
                              color: theme?.palette?.TmId.id.toString().includes('9') ? 'white' : 'black',
                            }}
                            align="right"
                          >
                            {/* ₹ {ele?.balanceDueAmt == 0 ? '0.00' : format(Number(ele?.balanceDueAmt))} */}₹{' '}
                            {Number(ele?.balanceDueAmt) === 0 ? '0.00' : MoneyFormatv3(ele?.balanceDueAmt)}
                          </TableCell>
                        );
                      })}
                      <TableCell
                        align="right"
                        sx={{
                          whiteSpace: 'nowrap',
                          // minWidth: '150px', // Adjust as needed
                          // width: '100%',
                          width: 'fit-content',
                          fontWeight: 'bold',
                          backgroundColor: theme?.palette?.TmId.id.toString().includes('9') ? 'black' : 'white',
                          color: theme?.palette?.TmId.id.toString().includes('9') ? 'white' : 'black',
                        }}
                      >
                        {/* ₹ {maxDaysTotalByCount == 0 ? '0.00' : format(Number(maxDaysTotalByCount))}  */}₹{' '}
                        {Number(maxDaysTotalByCount) === 0 ? '0.00' : MoneyFormatv3(maxDaysTotalByCount)}
                      </TableCell>
                      <TableCell
                        align="right"
                        sx={{
                          whiteSpace: 'nowrap',
                          // minWidth: '150px', // Adjust as needed
                          // width: '100%',
                          width: 'fit-content',
                          fontWeight: 'bold',
                          position: 'sticky',
                          right: 0,
                          borderLeft: '3px solid #0000001f !important',

                          backgroundColor: theme?.palette?.TmId.id.toString().includes('9') ? 'black' : 'white',
                          color: theme?.palette?.TmId.id.toString().includes('9') ? 'white' : 'black',
                        }}
                      >
                        ₹ {Number(totalAmtByTotalCount) === 0 ? '0.00' : MoneyFormatv3(totalAmtByTotalCount)}
                        {/* {totalAmtByTotalCount + maxDaysTotalByCount == 0
                          ? '0.00'
                          : format(Number(totalAmtByTotalCount + maxDaysTotalByCount))} */}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : (
                  <TableBody>
                    <TableRow>
                      <TableCell
                        colSpan={tableCell?.length}
                        align="center"
                        sx={{
                          color: '#818694',
                          fontFamily: 'overpass',
                          fontSize: 15,
                          fontWeight: 'bold',
                        }}
                      >
                        {backdropOpen === true ? 'Loading...' : 'NO DATA FOUND'}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
            {filterData.length > 0 && (
              <TablePagination
                rowsPerPageOptions={defaultRowsPerPageOptions}
                component="div"
                count={filterData?.[0]?.totalCount}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={(event, newPage) => {
                  if (newPage > page) {
                    if (filterData?.length !== filterData?.[0]?.totalCount)
                      if (filterData.length < rowsPerPage * (newPage + 1)) {
                        getAgeingData(
                          dateRange,
                          customDate,
                          '',
                          filterData?.length,
                          Math.abs(rowsPerPage * (newPage + 1) - filterData.length),
                          true,
                          1
                        );
                      }
                  }
                  setPage(newPage);
                }}
                onRowsPerPageChange={(event) => {
                  setRowsPerPage(parseInt(event.target.value, 10));
                  setPage(0);
                }}
              />
            )}
          </>
          {/* )} */}

          <CustomDateModal
            open={customDateModal}
            setOpen={setCustomDateModal}
            setmodalStartDate={setmodalStartDate}
            setmodalEndDate={setmodalEndDate}
            modalEndDate={modalEndDate}
            modalStartDate={modalStartDate}
          />
          <Snackbar
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'center',
            }}
            open={warningSnakbar}
            autoHideDuration={6000}
            onClose={() => setWarningSnakbar(false)}
          ></Snackbar>
        </Box>
      </Box>
    </Box>
  );
};

export default NewPayableReceivableAgeingTable;
